
    import '/opt/buildhome/repo/packages/x/components/think/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["think-demo-basic","think-demo-status","think-demo-expand","think-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/think/index.en-US.md?type=demo')
};